import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Redirect, RouteComponentProps } from "react-router";
import { LoadingContainer } from "go-core/components/Loading";
import { InvitationApi } from "../../../services/Api/Organization/organizationTypes";
import { api } from "../../../services/Security/api";
import { useAuth } from "../../../services/Security/auth";
import { selectIsAuthenticated } from "../../../services/session/selectors";
import { selectUser } from "../../../services/users/selectors";
import LoginForm from "../components/LoginForm";
import LoginLayout from "../components/LoginLayout";
import EmptyInvitation from "./components/EmptyInvitation";
import InvitationForDifferentUser from "./components/InvitationForDifferentUser";
import NoUserInvitation from "./components/NoUserInvitation";

const InvitationPage = (props: RouteComponentProps) => {
	const { t } = useTranslation();
	const [invitation, setInvitation] = useState<InvitationApi | undefined>();
	const [loading, setLoading] = useState(true);
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const [authLoading, setAuthLoading] = useState(!isAuthenticated);
	const auth = useAuth();
	const searchParams = new URLSearchParams(window.location.search);
	const user = useSelector(selectUser);
	const acceptationCode = searchParams.get("acceptation_code");

	useEffect(() => {
		init();
	}, []);

	const init = async () => {
		if (acceptationCode) {
			try {
				const res = await api.getLoginInvitation(acceptationCode, { include: "user,organization" });
				setInvitation(res);
				setLoading(false);
			} catch (err) {
				setLoading(false);
			}
		}
		if (!isAuthenticated) {
			try {
				await auth.checkLogin();
				setAuthLoading(false);
			} catch (err) {
				setAuthLoading(false);
			}
		}
	};

	if (loading || authLoading) {
		return <LoadingContainer />;
	}

	if (!acceptationCode) return <EmptyInvitation />;

	if (isAuthenticated) {
		if (invitation === undefined) {
			return <EmptyInvitation />;
		}

		if (user) {
			if (invitation.email === user.email) return <Redirect to="/" />;
			return <InvitationForDifferentUser invitation={invitation} />;
		}
	}

	if (invitation === undefined) {
		return <EmptyInvitation />;
	}

	if (invitation?.user === undefined) {
		return <NoUserInvitation invitation={invitation} location={props.location} acceptationCode={acceptationCode} />;
	}

	return (
		<LoginLayout>
			<p>
				{t("modules.security.field.invited.title")}
				<strong> {invitation.organization.name}</strong>. {t("modules.security.field.login_to_continue.title")}
			</p>
			<LoginForm email={invitation.email} location={props.location} />
		</LoginLayout>
	);
};

export default InvitationPage;
